import { render, staticRenderFns } from "./UsersReview.vue?vue&type=template&id=1e3d2889&scoped=true&"
import script from "./UsersReview.vue?vue&type=script&lang=js&"
export * from "./UsersReview.vue?vue&type=script&lang=js&"
import style0 from "./UsersReview.vue?vue&type=style&index=0&id=1e3d2889&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3d2889",
  null
  
)

export default component.exports